import React from 'react';
import { Form } from 'react-bootstrap'

const Search = ({search, searchInput, handleSearch}) => {

    return (
        <div>
            <Form.Group className="mb-3">
                <Form.Control value={search} ref={searchInput} onChange={handleSearch}  type="search" placeholder="Nombre de la Coordinadora que te refirió *" className='form_input_new'/>
            </Form.Group>
        </div>
    )

}

export default Search;